module.exports = __webpack_public_path__ + "static/img/real1.997dc96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/demo/real1.jpg
// module id = 95tp
// module chunks = 1